import * as bootstrap from 'bootstrap';
import * as html from './html';
import { GetIconLibrary } from './icons';

declare interface myWindow extends Window {
    readonly $: unknown;
}
declare const window: myWindow;

const jQueryToastSupport = () => typeof window.$ === 'function' && Object.prototype.hasOwnProperty.call(window.$, 'toast');

let iconStrCheck: string;
let iconStrError: string;
function updateToastIcons() {
    switch (GetIconLibrary()) {
    case 'fontAwesome4':
        iconStrCheck = '<i class="fa fa-check"></i>';
        iconStrError = '<i class="fa fa-times"></i>';
        break;
    case 'fontAwesome5':
        iconStrCheck = '<i class="fas fa-check"></i>';
        iconStrError = '<i class="fas fa-times"></i>';
        break;
    case 'materialSymbolsRounded':
        iconStrCheck = '<span class="material-symbols-rounded">check_circle</span>';
        iconStrError = '<span class="material-symbols-rounded">cancel</span>';
        break;
    }
}

let defaultToastClasses: string[] = ['align-items-center', 'text-white', 'border-0'];
let defaultToastCloseBtnClasses: string[] = ['btn-close-white', 'me-2', 'm-auto'];

export function SetDefaultToastClasses(classes: string[]) {
    defaultToastClasses = classes;
}

export function SetDefaultToastCloseBtnClasses(classes: string[]) {
    defaultToastCloseBtnClasses = classes;
}

export function Success(html: string) {
    updateToastIcons();
    if (jQueryToastSupport()) {
        $.toast({
            text: `${iconStrCheck} ${html}`,
            position: 'bottom-right',
            stack: 5,
            bgColor: '#2e7d32',
            hideAfter: 15 * 1000,
        });
    } else {
        return Show(`${iconStrCheck} ${html}`, ['bg-success']);
    }
}

export function Error(html: string) {
    updateToastIcons();
    if (jQueryToastSupport()) {
        $.toast({
            text: `${iconStrCheck} ${html}`,
            position: 'bottom-right',
            stack: 5,
            bgColor: '#dc3545',
            hideAfter: 15 * 1000,
        });
    } else {
        return Show(`${iconStrError} ${html}`, ['bg-danger']);
    }
}

let toastContainer: HTMLElement;

export function Show(h: string, classes: string[] = ['bg-primary']) {
    if (!toastContainer) {
        toastContainer = html.FromString(`
        <div class="toast-container position-fixed bottom-0 end-0 p-3"></div>`);
        document.body.appendChild(toastContainer);
    }

    const toastElement = html.FromString(`
    <div class="toast ${defaultToastClasses.join(' ')} ${classes.join(' ')}" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="d-flex">
            <div class="toast-body">
                ${h}
            </div>
            <button type="button" class="btn-close ${defaultToastCloseBtnClasses.join(' ')}" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
    </div>`);

    toastContainer.appendChild(toastElement);

    const toast = new bootstrap.Toast(toastElement, {
        delay: 15 * 1000,
    });
    toast.show();
    toastElement.addEventListener('hidden.bs.toast', () => {
        toast.dispose();
        toastElement.parentElement?.removeChild(toastElement);
    });

    return toast;
}